import './bootstrap';

import '../css/app.css';

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import analyticsPlugin from '@/plugins/analytics';
import { startNavigationTracker } from './composables/useNavigationTracker';

createInertiaApp({
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(analyticsPlugin);

        const {$analytics: analytics} = app.config.globalProperties    
        analytics.init(props.initialPage.props.config.analytics)
        startNavigationTracker();
        return app.mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});
